<template>
  <BaseGridView
    endpoint="v1/Supplier/GetData"
    :pageTitle="$t('Suppliers')"
    :columnDef="(columnDef as Array<ColumnModel>)"
    :searchOptions="_searchOptions"
    :templateDef="templateDef"
  >
    <template #supplier_isActive="{ rowData }">
      <span
        :class="rowData.value ? 'badge badge-success' : 'badge badge-danger'"
      >
        {{ rowData.value ? "Active" : "Inactive" }}
      </span>
    </template>
  </BaseGridView>
</template>

<script lang="ts" setup>
import { ColumnModel } from "@syncfusion/ej2-vue-grids";
import { getCurrentInstance, onBeforeMount, ref } from "vue";
import BaseGridView from "../../common/BaseGridView.Component.vue";
import { SearchOption, TemplateDef } from "../../common/CommonInterfaces";
import { GridConfig } from "../../common/Constants";

let columnDef = ref([] as ColumnModel[]);
const templateDef: TemplateDef = {
  prefix: "supplier",
  columnNames: ["isActive"],
};
const _searchOptions = {
  fields: [
    "company.Name",
    "name",
    "contactCreatedDateTimeOffset",
    "currencyCode",
    "emailAddress",
    "lastChangedDateTimeOffset",
    "phoneNumber",
    "websiteUrl",
  ],
  operator: "contains",
  ignoreCase: true,
} as SearchOption;

const app = getCurrentInstance();

onBeforeMount(() => {
  assignColumnDef();
});

const assignColumnDef = () => {
  const instance = app?.proxy;
  columnDef.value = [
    {
      field: "companyName",
      headerText: instance?.$t("companyName"),
      textAlign: "Center",

    },
    { field: "name", headerText: instance?.$t("name") },
    { field: "currencyCode", headerText: instance?.$t("currencyCode") },
    {
      field: "contactCreatedDateTimeOffset",
      headerText: instance?.$t("contactCreatedDate"),
      type: "date",
      format: GridConfig.dateFormat,
    },
    { field: "emailAddress", headerText: instance?.$t("emailAddress") },
    {
      field: "isActive",
      headerText: instance?.$t("status"),
      template: "supplier_isActive",
    },
    {
      field: "lastChangedDateTimeOffset",
      headerText: instance?.$t("lastChangedDate"),
      type: "date",
      format: GridConfig.dateFormat,
    },
    { field: "phoneNumber", headerText: instance?.$t("phoneNumber") },
    { field: "websiteUrl", headerText: instance?.$t("website") },
  ];
};
</script>
